import { render } from "./PatientsIndex.vue?vue&type=template&id=28425368&scoped=true"
import script from "./PatientsIndex.vue?vue&type=script&lang=js"
export * from "./PatientsIndex.vue?vue&type=script&lang=js"

import "./PatientsIndex.vue?vue&type=style&index=0&id=28425368&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28425368"]])

export default __exports__